import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}


export function unknownToString(
  value: unknown,
  fallback = "",
): string {
  return (
    typeof value === "string" ||
    typeof value === "number"
      ? String(value)
      : fallback
  )
}


export function unknownToNumber(
  value: unknown,
  fallback = undefined,
): number {
  return (
    typeof value === "number"
      ? Number(value)
      : fallback
  )
}


export function toMetadata(
  value: object | unknown | null | undefined,
): Record<string, unknown> | null {
  if (!value) return null;

  return Object.fromEntries(
    Object.entries(value),
  );
}


export function withTimeout<T>(promise: Promise<T>, ms: number): Promise<T> {
  return Promise.race([
    promise,
    new Promise<never>((_, reject) =>
      setTimeout(() => reject(new Error('Timeout')), ms)
    ),
  ]);
}


export function resolveAssetUrl(path?: string) {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  const base = import.meta.env.VITE_ASSETS_BASE_URL || 'https://assets.artimindedu.com';
  return `${base}${path.startsWith('/') ? '' : '/'}${path}`;
}


export function getErrorMessage(
  error: unknown,
  fallback = "An unknown error occurred",
): string {
  if (error instanceof Error && error.message) {
    return error.message;
  }

  try {
    const message = String(error);
    return message || fallback;
  } catch {
    return fallback;
  }
}
